package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import kotlinx.coroutines.flow.Flow

class SubmitAnswerUseCase(
    private val answerRepository: AnswerRepository
) {
    operator fun invoke(
        answer: AnswerModel,
        answerType: InspectionAnswerType
    ): Flow<FlowResult<String?>> {
        return answerRepository.submitAnswer(answer, answerType)
    }
}
